import { render, staticRenderFns } from "./AdvertisingHistoryCard.vue?vue&type=template&id=55b2c4ae&scoped=true&"
import script from "./AdvertisingHistoryCard.vue?vue&type=script&lang=js&"
export * from "./AdvertisingHistoryCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b2c4ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
